import React from "react";
import { SliceComponentProps } from "@prismicio/react";

import { PrismicLandingPageV2DataBodyFunctionalitydemonstration } from "@www/graphql-types";

import * as Styled from "./FunctionalityDemonstration.styled";
import { Functionality } from "./Functionality/Functionality";

export const FunctionalityDemonstration = (
  props: SliceComponentProps<PrismicLandingPageV2DataBodyFunctionalitydemonstration>,
) => {
  const items = props.slice.items;

  return (
    <Styled.StyledScrollZone isSection>
      {items.map((item, index) => (
        <Functionality key={index} {...item} />
      ))}
    </Styled.StyledScrollZone>
  );
};
